/**
 * Final say where area dictionaries disagree, plus context-specific entries
 * (`context|english`) looked up by tc(). Keeps terminology consistent.
 */
export const DE_OVERRIDES: Readonly<Record<string, string>> = {
  'DOWNLOAD DIAGNOSTICS': 'DIAGNOSE HERUNTERLADEN',
  'Could not download diagnostics': 'Diagnose konnte nicht heruntergeladen werden',
  // Shared terminology
  'SLINGSHOT': 'KATAPULT',
  'AIR': 'AIRTIME',
  'CLEAN PASS': 'SAUBER ÜBERHOLT',
  'LOOP MASTER': 'LOOPING-PROFI',
  'REWIND': 'RÜCKSPULEN',
  'APEX HUNTER': 'APEX-JÄGER',
  'DAWN': 'MORGENGRAUEN',
  'SUNSET': 'ABENDROT',
  'BULLY': 'RAUBEIN',
  'ROOKIE': 'ROOKIE',
  'PRO': 'PROFI',
  'LOOP': 'SCHLEIFE',
  'BRAKE': 'BREMSE',
  'SOUND OFF': 'TON AUS',
  'SOUND ON': 'TON AN',
  'INTEGRITY': 'INTEGRITÄT',
  'PRIVATE GRID ACCESS': 'PRIVATER GRID-ZUGANG',
  'CLOSE': 'SCHLIESSEN',
  'OPEN': 'ÖFFNEN',
  'QR code containing the private race invite link': 'QR-Code mit dem privaten Einladungslink',
  'JOIN THE<br>NIGHT SHIFT.': 'AB IN DIE<br>NACHTSCHICHT.',
  'Scan the QR code or send the private link. Anyone who has it can claim an open grid slot before launch.': 'Scanne den QR-Code oder schick den privaten Link. Wer ihn hat, kann sich vor dem Start einen freien Startplatz sichern.',
  'Damage by side: none': 'Schaden pro Seite: keiner',
  'Tap to rotate, hold to drift and earn exit nitro': 'Tippen zum Eindrehen, halten zum Driften – bringt Nitro am Kurvenausgang',
  'TILT MODE': 'NEIGUNGSMODUS',
  'RESUME': 'FORTSETZEN',
  'BUTTON SIZE': 'TASTENGRÖSSE',
  'NEUTRAL DEAD ZONE': 'TOTZONE MITTE',
  'TILT RESPONSE': 'NEIGUNGS-ANSPRACHE',
  'ENABLE TILT STEERING': 'NEIGUNGSLENKUNG AN',
  'Hold the device naturally and keep it centred': 'Halte das Gerät natürlich und ruhig in der Mitte',
  'CHECKING…': 'PRÜFE …',
  'Connect a controller and press any button. Wired and Bluetooth pads are detected automatically.': 'Schließ einen Controller an und drück eine beliebige Taste. Kabel- und Bluetooth-Pads werden automatisch erkannt.',
  'STEERING RESPONSE': 'LENKANSPRACHE',
  'RACE FINISH': 'ZIELEINLAUF',
  'TIMED EVENT': 'ZEIT-EVENT',
  'CLEAN FINISH': 'SAUBERES FINISH',
  'NIGHT RUNNER': 'NACHTFAHRER',
  'RESET LOCAL DATA': 'LOKALE DATEN LÖSCHEN',
  'ARCADE LAB': 'ARCADE LAB',
  'NIGHT TOUR // {tour}': 'NIGHT TOUR // {tour}',
  'TOUR COMPLETE': 'TOUR GESCHAFFT',
  'STREET SPRINT RESULTS': 'ERGEBNIS STRASSENSPRINT',
  'STYLE RUSH RESULTS': 'ERGEBNIS STYLE RUSH',
  'ROAD RAGE RESULTS': 'ERGEBNIS ROAD RAGE',
  'LAST DRIVER STANDING': 'LETZTER ÜBERLEBENDER',
  'REAL-TIME RACE NETWORK': 'ECHTZEIT-RENNNETZWERK',

  'INSTALL ↘': 'APP ↘',
  'DAILY SEEDED TIME ATTACK': 'DAILY-ZEITFAHREN',
  'RUN DAILY →': 'DAILY STARTEN →',

  // Language step and switch
  'LANGUAGE': 'SPRACHE',
  'Language': 'Sprache',
  'Go to language': 'Zur Sprachwahl',

  // Context-specific (tc)
  'action|CLEAR': 'LEEREN',
  'coach|BRAKE': 'BREMSEN',
  'stunt|LOOP': 'LOOPING',
  'camera|CLOSE': 'NAH',
  'camera|close': 'nah',
  'connection|OPEN': 'VERBUNDEN',
  'key|SHIFT': 'SHIFT',
  'key|R-SHIFT': 'R-SHIFT',

  // Proper names that stay English (listed so the missing-string check stays quiet)
  'HEAT RUN': 'HEAT RUN',
  'ROAD RAGE': 'ROAD RAGE',
  'STYLE RUSH': 'STYLE RUSH',
  'HEAVY METAL': 'HEAVY METAL',
  'NITRO RUSH': 'NITRO RUSH',
};
